export default {
    book: 'Réserver {product}',
    age_limit: 'Réservé aux plus de {age} ans',
    change_plan: 'Changer de plan',
    upgrade_product: 'Améliorer le produit',
    upgrade: 'Améliorer',
    cancel_upgrade: "Annuler l'amélioration",
    choose_product: 'Choisir {product}',
    days: '{count} jour | {count} jours',
    login_register: 'Connexion/Inscription',
    current: 'Actuel',
    keyless_benefits: {
        label: 'Directement à la voiture {0}',
        highlight: 'service de location™',
        list: {
            cant_lose_the_key: 'Assurance complète',
            zero_excess: 'Zéro franchise',
            phone_as_a_key: 'Téléphone comme clé',
            straight_to_car: 'Pas d’attente',
            no_queues: 'Pas de files d’attente',
            online_id_check: 'Vérification d’identité en ligne',
            self_checkout: 'Enregistrement autonome',
        },
    },
};
